module.exports = __webpack_public_path__ + "img/x-clear-icon-40x40.a5fe46e2.svg";